import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import { ArrowLeft } from "@mui/icons-material";

const BreadCrumbComponent = ({ heading1, heading2 }) => {
  const navigate = useNavigate();

  const breadcrumbs = [
    <Link
      key="2"
      href="#"
      onClick={() => navigate(window.location.pathname)}
      style={{
        textDecoration: "none",
        color: "#03293A",
        fontWeight: "500",
        fontSize: "16px",
      }}
    >
      {heading1}
    </Link>,
    <span>{`>`}</span>,
    <Typography key="3" color="#03293A" fontSize="16px" fontWeight={500}>
      {heading2}
    </Typography>,
  ];
  return (
    <Box width="100%" marginBottom="12px">
      <Breadcrumbs
        separator={<img src={ArrowLeft} alt={""} />}
        aria-label="breadcrumb"
        sx={{ '& .MuiBreadcrumbs-separator': { marginLeft: '4px', marginRight: "4px" } }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadCrumbComponent;
